import React, { useCallback } from "react";

import AppLayout from "../common/AppLayout";
import ProjectsList from "./components/ProjectsList";
import CreateProjectDialog from "./components/CreateProjectsDialog";

export default function Project() {
  const [openCreateProjectDialog, setOpenCreateProjectDialog] =
    React.useState(false);

  // Handlers for opening and closing the dialog
  const openDialog = useCallback(() => setOpenCreateProjectDialog(true), []);
  const closeDialog = useCallback(() => setOpenCreateProjectDialog(false), []);
  return (
    <AppLayout pageName="Projects" maxWidth={false}>
      <CreateProjectDialog
        open={openCreateProjectDialog}
        handleClose={closeDialog}
      />
      <ProjectsList handleProjectCreateDialog={openDialog} />
    </AppLayout>
  );
}
